import { render, staticRenderFns } from "./Service.vue?vue&type=template&id=1fc23c70&scoped=true&"
import script from "./Service.vue?vue&type=script&lang=js&"
export * from "./Service.vue?vue&type=script&lang=js&"
import style0 from "./Service.vue?vue&type=style&index=0&id=1fc23c70&scoped=true&lang=css&"
import style1 from "./Service.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc23c70",
  null
  
)

export default component.exports